import { Component, OnDestroy } from '@angular/core';
import { EditProductComponent } from 'components/admin/product/edit-product.component';
import { CredentialType } from 'enums/CredentialType';
import { HubAction } from 'enums/HubAction';
import { ProductModel } from 'models/generated/Entities.GormCrm.Product';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { ProductService } from 'services/product.service';
import { PushService } from 'services/push.service';

@Component({
	selector: 'list-products',
	templateUrl: './list-products.component.html',
	imports: [Layout, ListView, TranslatePipe]
})
@ComponentUrl('list-products')
@CredentialRequired(CredentialType.ProductsAccessFull)
export class ListProductsComponent implements OnDestroy {
	inactiveProducts?: ProductModel[];
	activeProducts?: ProductModel[];
	onProductChange: Subscription;
	selectedProductId?: string;

	constructor(private readonly navigation: NavigationService,
		private readonly productService: ProductService,
		private readonly pushService: PushService) {
		this.updateProductList();

		this.onProductChange = this.pushService.onProductChange.subscribe(event => {
			if (event.action == HubAction.Delete && this.selectedProductId && this.selectedProductId == event.data.productId) {
				this.navigation.refreshView(ListProductsComponent);
				return;
			}
			this.updateProductList();
		});
	}

	updateProductList() {
		this.productService.getAllProducts().then(products => {
			this.inactiveProducts = products.filter(p => !p.active);
			this.activeProducts = products.filter(p => p.active);
		});
	}

	displayProduct(productId?: string) {
		this.navigation.openRelativeView(this, 'editproduct', EditProductComponent).then(view => {
			this.selectedProductId = productId;
			if (productId) view.productId = productId;
		});
	}

	ngOnDestroy(): void {
		this.onProductChange.unsubscribe();
	}
}
